import routes from '@/router/routes'
import AuthMixin from '@/shared/mixins/auth.mixin'
import {
  getAppHostname,
  getLoginLogoPath,
  isPiauiHostname,
  isAmazonasHostname,
  isAlagoasHostname,
  isAmapaHostname
} from '@/shared/utils/hostname'

export default {
  name: 'login',
  components: {},
  mixins: [
    AuthMixin
  ],
  props: {
    isPiauiDomain: {
      type: Boolean,
      default: false
    },
    isAmazonasDomain: {
      type: Boolean,
      default: false
    },
    isAlagoasDomain: {
      type: Boolean,
      default: false
    },
    isAmapaDomain: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      logo: getLoginLogoPath(),
      authRoute: import.meta.env.VITE_AUTH_ROUTE,
      urlApi: import.meta.env.VITE_URL_API,
      routes,
      recaptchaPublicKey: import.meta.env.VITE_RECAPTCHA_PUBLIC_KEY
    }
  },
  computed: {
    loginHomeRoutes () {
      return {
        admin: `${window.location.origin}/admin/exames`,
        adminSource: `${window.location.origin}/admin/exames`,
        adminPhysician: `${window.location.origin}/admin/exames`,
        source: `${window.location.origin}/exames`,
        analyst: `${window.location.origin}/analista`,
        medicalDemand: import.meta.env.VITE_MEDICAL_DEMAND_URL
      }
    },
    isPiauiDomainFlag () {
      return isPiauiHostname()
    },
    isAmazonasDomainFlag () {
      return isAmazonasHostname()
    },
    isAlagoasDomainFlag () {
      return isAlagoasHostname()
    },
    isAmapaDomainFlag () {
      return isAmapaHostname()
    }
  },
  mounted () {
    localStorage.removeItem("selectedSource")

    const logoElement = this.$el.querySelector('.logo')
    const hostname = getAppHostname()
    const isPiauiLogo = this.logo.includes('logo-piaui-saude-digital.png')
    const isAmazonasLogo = this.logo.includes('logo-amazonas-saude-digital.png')
    const isAlagoasLogo = this.logo.includes('logo-alagoas-saude.png')
    const isAmapaLogo = this.logo.includes('logo-amapa-saude-da-gente-horizontal.png')

    if (logoElement) {
      if (isPiauiHostname(hostname) && isPiauiLogo) {
        logoElement.classList.add('piaui-logo')
      } else if (isAmazonasHostname(hostname) && isAmazonasLogo) {
        logoElement.classList.add('amazonas-logo')
      } else if (isAlagoasHostname(hostname) && isAlagoasLogo) {
        logoElement.classList.add('alagoas-logo')
      } else if (isAmapaHostname(hostname) && isAmapaLogo) {
        logoElement.classList.add('amapa-logo')
      }
    }

    const role = this.getFirstRole()
    if (role) {
      this.$router.push(`/${this.getHomePage()}`)
    }
    this.$root.$emit('hideLoading')
  },
  methods: {
    getLogoByURL () {
      return getLoginLogoPath()
    }
  }
}
